import React, { useState, useContext } from "react";
import { Platform, View } from "react-native";
import WebView, { WebViewNavigation } from "react-native-webview";
import { ScrollView } from "react-native-gesture-handler";
import { AuthContext } from "../contexts/auth/Store";
import Spinner from "../components/common/Spinner";
import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import GenericHeader from "../components/headers/GenericHeader";

const PaystackCheckoutScreen = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const auth = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [urlData, setUrlData] = useState<any>(null);

  const onNavigationStateChange = (state: WebViewNavigation) => {
    const callback_url =
      (Platform.OS === "web" ? window.location.host : "https://suplias.shop") +
      "/balance";
    const { url } = state;
    if (!url) return;
    if (url === callback_url) {
      navigation.navigate("Balance");
    } else if (url === "https://standard.paystack.co/close") {
      navigation.goBack();
    } else {
      // we shall take care of contigencies which may arise later
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      const params: any = route.params;
      if (params && params?.authorization_url) {
        setUrlData({ ...route.params });
      } else {
        setTimeout(() => {
          navigation.canGoBack()
            ? navigation.goBack()
            : navigation.navigate("Root");
        }, 2500);
      }
      return () => setUrlData(null);
    }, [navigation, route])
  );

  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        contentContainerStyle={{
          flex: 1,
          flexGrow: 1,
          overflow: "hidden",
        }}
      >
        <GenericHeader title="Pay with Transfer" />
        {loading && <Spinner />}
        {Platform.OS === "android" && urlData ? (
          <WebView
            source={{
              uri: `${urlData.authorization_url}`,
            }}
            style={{ opacity: 0.99 }}
            onLoadStart={() => {
              setLoading(true);
            }}
            onLoadEnd={() => {
              setLoading(false);
            }}
            onNavigationStateChange={onNavigationStateChange}
          />
        ) : null}
      </ScrollView>
    </View>
  );
};

export default PaystackCheckoutScreen;
